<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body no-body-scroll" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    @if (activeTab === 'explainVariance') {
<div class="tab-pane active">
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4">
            <div>
              <label>Variance Explanation: </label>

              @if (!explDataLoaded && !loadFailed) {
<div class="gt-filter-loading">
                <i style="color: #e12827; font-size: 36px;" class="fa fa-spinner fa-spin"></i>
              </div>
}

              @if (loadFailed) {
<div class="alert alert-warning">
                No explanations available.
              </div>
}

              @if (explDataLoaded) {
<div>
                <select
                  gtwSearchableSelect
                  class="form-control"
                  [(ngModel)]="varianceExpln"
                  name="varianceExplanation"
                  (ngModelChange)="onVarianceExplnChange()"
                >
                  <option [ngValue]="null">Select Explanation...</option>
                  @for (item of explDropdownData; track $index) {
<option [ngValue]="item">
                    {{ item.EXPL_DESC }}
                  </option>
}
                </select>
              </div>
}
            </div>
          </div>

          <div class="col-md-1">
            <div class="remove-action-cell">
              @if (showRemoveBtn) {
<button class="btn btn-danger btn-xs remove-action-btn"
                   type="button"
                  
                   (click)="removeVarianceExpln()">
                <i class="fa fa-times"></i>
                <span>Remove</span>
              </button>
}
            </div>
          </div>

          <div class="col-md-4 col-md-offset-2 other-expln-col">
            @if (showOtherExpln) {
<div class="form-group">
              <label>Other Explanation: </label>
              <input type="text"
                     [(ngModel)]="otherExplainText"
                     class="form-control" />
            </div>
}
          </div>
        </div>
      </div>
    </div>
}

    @if (activeTab === 'setupExplanation') {
<div class="tab-pane active">
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>New Explanation: </label>
              <input type="text"
                     [(ngModel)]="explainText"
                     class="form-control" />
            </div>
          </div>
        </div>
      </div>
    </div>
}
  </div>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="btn btn-default btn-sm"
          type="button"
          (click)="reset()">Reset</button>
  <button class="btn btn-warning btn-sm"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onConfirmYes()"
    (cancelled)="onConfirmNo()"
    (closed)="onConfirmNo()">
  </gtw-confirmation-modal>
</div>
}
